import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import useProfileSx from '../../hooks/useProfileSx';

export default function PermissionNodeToggle({
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange,
}) {
  const sx = useProfileSx();

  return (
    <Box sx={sx.permissionTreeNodeToggle}>
      <Checkbox
        size="small"
        checked={Boolean(checked)}
        indeterminate={indeterminate}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.checked)}
        onClick={(event) => event.stopPropagation()}
        sx={sx.permissionMatrixCheckbox}
      />
      <Typography
        variant="body2"
        sx={checked ? sx.permissionMatrixYes : sx.permissionMatrixNo}
      >
        {checked ? 'Yes' : 'No'}
      </Typography>
    </Box>
  );
}
